<script setup lang="ts">
const form = useForm({
	method: 'PUT',
	url: route('user-password.update'),
	fields: {
		current_password: '',
		password: '',
		password_confirmation: '',
	},
	errorBag: 'updatePassword',
	reset: true,
	hooks: {
		error: (errors) => {
			if (errors.password) {
				form.clear('password', 'password_confirmation')
			}

			if (errors.current_password) {
				form.clear('current_password')
			}
		},
	},
})
</script>


					<script lang="ts">
					import __hybridly_layout_0 from '~/resources/layouts/default.vue';
					export default { layout: [__hybridly_layout_0] }
					</script>
					<template>
				
	<content-wrapper>
		<user-submenu />

		<ui-form variant="settings" @submit.prevent="form.submit">
			<ui-form-settings-item>
				<template #label>
					<ui-label for="current_password">
						{{ t('validation.attributes.current_password') }}
					</ui-label>
				</template>

				<ui-input
					id="current_password"
					v-model="form.fields.current_password"
					type="password"
					autocomplete="current-password"
				/>
				<ui-form-error :message="form.errors.current_password" />
			</ui-form-settings-item>

			<ui-form-settings-item>
				<template #label>
					<ui-label for="password">
						{{ t('validation.attributes.new_password') }}
					</ui-label>
				</template>

				<ui-input
					id="password"
					v-model="form.fields.password"
					type="password"
					autocomplete="new-password"
				/>
				<ui-form-error :message="form.errors.password" />
			</ui-form-settings-item>

			<ui-form-settings-item>
				<template #label>
					<ui-label for="password_confirmation">
						{{ t('validation.attributes.password_confirmation') }}
					</ui-label>
				</template>

				<ui-input
					id="password_confirmation"
					v-model="form.fields.password_confirmation"
					type="password"
					autocomplete="new-password"
				/>
				<ui-form-error :message="form.errors.password_confirmation" />
			</ui-form-settings-item>

			<ui-separator />

			<ui-button :loading="form.processing" class="w-fit" @click="form.submit">
				{{ t('app.buttons.save') }}
				<template #icon>
					<i-ph-arrow-right />
				</template>
			</ui-button>
		</ui-form>
	</content-wrapper>
</template>
